import React, { useState, useEffect } from "react";
import { Select, Form, Row, Col } from "antd";
import liracrypt from "../../Liracrypt/liracrypt";
import SessionError from "../../ApiErrorComp/SessionError";
import ApiErrorComp from "../../ApiErrorComp/ApiErrorComp";

function Idame({
  form,
  type,
  labelCol,
  url,
  urlData,
  idName,
  idLabel,
  idRequired,
  colSpan,
  idErrorMessage,
  idPlaceholder,
  idMultiSelect,
  defaultIdValue,
  defaultNameValue,
  nameName,
  nameLabel,
  nameRequired,
  nameErrorMessage,
  namePlaceholder,
  nameMultiSelect,
  disabled,
  defaultValue,
  width,
  cross,
  firstSelected,
  includeAll,
  fetchFromCache,
  style
}) {
  const [id, setID] = useState([]);
  const [name, setName] = useState([]);
  const [data, setData] = useState([]);
  const [loginError, setLoginError] = useState(false);


  function setPhantomData(key, value) {
    const now = new Date();

    const item = {
      value: value,
      expiry: now.getTime() + 600000,
    };
    localStorage.setItem(key, JSON.stringify(item));
  }

  function getPhantomData(key) {
    if (!fetchFromCache) {
      return;
    }
    const itemStr = localStorage.getItem(key);
    // if the item doesn't exist, return null
    if (!itemStr) {
      return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();
    // compare the expiry time of the item with the current time
    // if (now.getTime() > item.expiry) {
    //   // If the item is expired, delete the item from storage
    //   // and return null
    //   localStorage.removeItem(key);
    //   return null;
    // }
    return item.value;
  }

  function getKeyByValue(object, value) {
    return Object.keys(object).find((key) => object[key] === value);
  }
  // form.setFieldsValue({ [name]: defaultNameValue });
  // form.setFieldsValue({ [id]: defaultIdValue });

  useEffect(() => {
    const d = getPhantomData(urlData["typ"] + "_" + urlData["subTyp"]);
    console.log(d);
    if (d) {
      // setData(d);
      const idList = [];
      const nameList = [];

      Object.keys(d).forEach((item, index) => {
        // console.log(item, d[item]);
        if (includeAll && index === 0) {
          idList.push({ label: "All", value: "all" });
          nameList.push({ label: "All", value: "all" });
          setData({ ...d, All: "all" });
        }
        idList.push({ label: d[item], value: item });
        nameList.push({
          label: d[item],
          value: cross ? item : d[item],
        });
      });
      setData(d);
      // if (includeAll) {
      //   idList.push({ label: "All", value: "All" });
      // }

      console.log(nameList);

      setID(idList);
      setName(nameList);
    } else {
      liracrypt
        .get(url, urlData)
        .then((res, req) => {
          const idList = [];
          const nameList = [];
          setData(res.data.data);

          setPhantomData(urlData["typ"] + "_" + urlData["subTyp"], res.data.data);

          Object.keys(res.data.data).forEach((item, index) => {
            // console.log(res.data.data);
            if (includeAll && index === 0) {
              idList.push({ label: "All", value: "all" });
              nameList.push({ label: "All", value: "all" });
              setData({ ...res.data.data, All: "all" });
            }
            idList.push({ label: item, value: res.data.data[item] });
            nameList.push({
              label: res.data.data[item],
              value: cross ? item : res.data.data[item],
            });
          });

          // if (includeAll) {
          //   idList.push({ label: "All", value: "All" });
          // }

          setID(idList);
          setName(nameList);
        })
        .catch((err) => {
          if (err.response !== undefined) {
            if (err.response.status !== 401) {
              ApiErrorComp(err.response.status);
            } else {
              setLoginError(true);
            }
          }
        });
    }
    if (defaultNameValue) {
      form.setFieldsValue({ [name]: defaultNameValue });
      form.setFieldsValue({ [id]: getKeyByValue(data, defaultNameValue) });
    }
  }, [urlData]);

  return (
    <>
      <SessionError visible={loginError} />
      {type === "idame" ? (
        <Col span={colSpan ? colSpan : 24}>
          <Form.Item
            labelCol={{ span: labelCol || 8 }}
            initialValue={defaultIdValue ? defaultIdValue : null}
            name={idName}
            labelAlign={"left"}
            label={type === "idame" ? idLabel : null}
            style={{
              marginRight: "10px",
              display: type === "idame" ? "" : "none",
              width: width,
              fontWeight: 600,
            }}
            rules={[
              {
                required: idRequired,
                message: idErrorMessage,
              },
            ]}
          >
            {type === "idame" ? (
              <Select
                onChange={(value) => {
                  form.setFieldsValue({ [`${nameName}`]: data[value] });
                }}
                defaultValue={defaultIdValue ? defaultIdValue : null}
                disabled={disabled}
                showSearch={true}
                style={{ fontWeight: 600 }}
                placeholder={idPlaceholder}
                mode={idMultiSelect ? "multiple" : null}
                defaultActiveFirstOption={firstSelected ? firstSelected : false}
              >
                {/* {includeAll ? (
                  <Select.Option value={"All"} key={1001}>
                    {"All"}
                  </Select.Option>
                ) : (
                  <></>
                )} */}
                {id &&
                  id.map((item, index) => {
                    // console.log(item);
                    return (
                      <Select.Option value={item.value} key={index}>
                        {item.label}
                      </Select.Option>
                    );
                  })}
              </Select>
            ) : (
              <></>
            )}
          </Form.Item>
        </Col>
      ) : (
        <></>
      )}
      <Col style={style} span={colSpan ? colSpan : 24}>
        {type === "name" ? (
          <Form.Item
            name={idName}
            initialValue={defaultNameValue ? defaultNameValue : null}
            style={{ display: "none", fontWeight: 600 }}
          ></Form.Item>
        ) : (
          <></>
        )}
        <Form.Item
          labelCol={{ span: labelCol || 8 }}
          initialValue={defaultNameValue ? defaultNameValue : null}
          name={nameName}
          label={nameLabel}
          style={{ marginRight: "10px", fontWeight: 600 }}
          rules={[
            {
              required: nameRequired,
              message: nameErrorMessage,
            },
          ]}
        >
          <Select
            onChange={(value) => {
              // console.log(getKeyByValue(data, value));

              console.log(value, getKeyByValue(data, value), data);
              if (nameMultiSelect) {
                let valueArray = [];
                value.forEach((d, i) => {
                  if (d === "All") {
                    valueArray.push("all");
                  } else {
                    valueArray.push(getKeyByValue(data, d));
                  }
                });
                form.setFieldsValue({
                  [`${idName}`]: valueArray,
                });
              } else {
                form.setFieldsValue({
                  [`${idName}`]: getKeyByValue(data, value),
                });
              }
            }}
            defaultValue={defaultNameValue ? defaultNameValue : null}
            disabled={disabled}
            mode={nameMultiSelect ? "multiple" : null}
            showSearch={true}
            placeholder={namePlaceholder}
            style={{ fontWeight: 600 }}
            defaultActiveFirstOption={firstSelected ? firstSelected : false}
            options={name ? name : []}
          >
            {/* {name.map((item, index) => {
              return (
                <Select.Option
                  style={{ fontWeight: 600 }}
                  value={item.value}
                  key={index}
                >
                  {item.label}
                </Select.Option>
              );
            })} */}
          </Select>
        </Form.Item>
      </Col>
    </>
  );
}

export default Idame;
